import { signal } from '@preact/signals';

/** True when a new service worker is waiting; the shell shows "Update ready, restart?" (§9.13). */
export const updateReady = signal(false);
let applyUpdate: ((reload?: boolean) => Promise<void>) | null = null;

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  void import('virtual:pwa-register').then(({ registerSW }) => {
    applyUpdate = registerSW({
      immediate: true,
      onNeedRefresh() {
        updateReady.value = true;
      },
    });
  });
}

/** Accept the waiting service worker: skipWaiting + reload. */
export async function acceptUpdate(): Promise<void> {
  if (applyUpdate) await applyUpdate(true);
}
